import React, { useContext, useEffect } from 'react'
import InstanceContext from '../../context/InstanceContext/InstanceContext';
import { getTenantInfoByKey } from '../../helpers/helpers';
import { EmptyStateTwo } from '../Empty/EmptyStateTwo';
import { t } from 'i18next';
import { ExactianLoader } from '../../ui/components';

const InstanceMiddleware = ({ children }) => {
    const { instanceInfoState, instanceInfoGet } = useContext(InstanceContext);
    const { isFetching, error, message } = instanceInfoState;

    const isAccessAppEnabled = getTenantInfoByKey('access_enabled');

    useEffect(() => {
        instanceInfoGet();
        // eslint-disable-next-line
    }, [])

    if (error === true) {
        return (
            <div className='pt-5'>
                <EmptyStateTwo message={message} />
            </div>
        );
    }

    if (isFetching === true) {
        return (
            <div className='d-flex justify-content-center align-items-center h-100'>
                <ExactianLoader />
            </div>
        );
    }

    if (isFetching === false && isAccessAppEnabled === false) {
        return (
            <div className='pt-5'>
                <EmptyStateTwo message={t('INSTANCE_NOT_CONFIG_TO_ENTRY')} />
            </div>
        );
    }

    return children

}

export default InstanceMiddleware